import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import { useClasseSection } from "./use-classe-section";
import { ClasseSectionView } from "./view-classe-section";

export function ClasseSection(props: EmbarcacaoDetailSectionProps) {
  const vm = useClasseSection(props);

  return <ClasseSectionView {...vm} />;
}

export type * from "./types-classe-section";
